import React from "react";
import T from "prop-types";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { DAYS, END_DATE, FILTERS, MONTH, START_DATE } from "APP_ROOT/constants";

function Picker({ pageActions: { setFilter }, paginator }) {
  const params = paginator.get(FILTERS).toJS();

  const start = params.start_date && moment(params.start_date);
  const end = params.end_date && moment(params.end_date);

  const handleCallback = (startVal, endVal) => {
    setFilter(START_DATE, startVal.isValid() ? startVal : null);
    setFilter(END_DATE, endVal.isValid() ? endVal : null);
  };

  const handleCancel = (ev, picker) => {
    setFilter(START_DATE, null);
    setFilter(END_DATE, null);
    picker.val("");
  };

  const label =
    start && start.isValid() && end && end.isValid()
      ? `${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`
      : null;

  return (
    <DateRangePicker
      initialSettings={{
        startDate:
          (start && start.toDate()) ||
          moment()
            .subtract(30, DAYS)
            .toDate(),
        endDate: (end && end.toDate()) || moment().toDate(),
        locale: {
          cancelLabel: "Clear"
        },
        alwaysShowCalendars: true,
        ranges: {
          Today: [moment().toDate(), moment().toDate()],
          Yesterday: [
            moment()
              .subtract(1, DAYS)
              .toDate(),
            moment()
              .subtract(1, DAYS)
              .toDate()
          ],
          "Last 7 Days": [
            moment()
              .subtract(6, DAYS)
              .toDate(),
            moment().toDate()
          ],
          "Last 30 Days": [
            moment()
              .subtract(29, DAYS)
              .toDate(),
            moment().toDate()
          ],
          "This Month": [
            moment()
              .startOf(MONTH)
              .toDate(),
            moment()
              .endOf(MONTH)
              .toDate()
          ],
          "Last Month": [
            moment()
              .subtract(1, MONTH)
              .startOf(MONTH)
              .toDate(),
            moment()
              .subtract(1, MONTH)
              .endOf(MONTH)
              .toDate()
          ]
        }
      }}
      onCallback={handleCallback}
      onCancel={handleCancel}
    >
      <span className="input-group-btn">
        <button type="button" className="btn btn-success ">
          <i className="fa fa-calendar" />
          &nbsp;
          <span>{label}</span> <i className="fa fa-caret-down" />
        </button>
      </span>
    </DateRangePicker>
  );
}

Picker.propTypes = {
  pageActions: T.shape({}),
  paginator: T.instanceOf(Map)
};

export default Picker;



// WEBPACK FOOTER //
// ./app/modules/shared/components/DateRangePicker/DateRangePicker.jsx